import React from "react";
import { connect } from "react-redux";

import { bindActionCreators } from "redux";

import { changeTenant } from "ui/app/app.actions";
import { IUserRoleAccess } from "ui/shared/models/common";

import { AppUserContext, UserContext } from "./UserContext";
import { userActions } from "./UserProvider.actions";
import { IUserState } from "./UserProvider.state";

interface IUserProviderProps {
  userState: IUserState;
  trySignIn: () => void;
  signIn: (redirectUri?: string) => void;
  completeSignIn: () => void;
  signOut: () => void;
  authorize: () => void;
  changeTenant: (tenantId: string) => void;
  changeUserRoleAccessData: (userRoleAccessData: IUserRoleAccess) => void;
}

export const UserProvider: React.FC<IUserProviderProps> = ({
  userState,
  children,
  trySignIn,
  signIn,
  authorize,
  completeSignIn,
  signOut,
  changeTenant,
  changeUserRoleAccessData
}) => {
  const userContextValue = new AppUserContext({
    user: userState,
    initiateAuthentication: (remote: boolean, redirectUri?: string) => {
      if (remote) {
        signIn(redirectUri);
      } else {
        trySignIn();
      }
    },
    completeSignIn: () => {
      completeSignIn();
    },

    authorize: () => {
      authorize();
    },

    signOut: () => {
      signOut();
    },

    setTenant: (tenantId: string) => {
      changeTenant(tenantId);
    },
    setUserRoleAccessData: (userRoleAccessData: IUserRoleAccess) => {
      changeUserRoleAccessData(userRoleAccessData);
    }
  });

  return <UserContext.Provider value={userContextValue}>{children}</UserContext.Provider>;
};

export default connect(
  (state: { user: IUserState }) => {
    return {
      userState: state.user
    };
  },
  (dispatch: any) => {
    return bindActionCreators(
      {
        authorize: userActions.authorize,
        trySignIn: userActions.trySignIn,
        signIn: userActions.signIn,
        completeSignIn: userActions.completeSignIn,
        signOut: userActions.signOut,
        changeTenant: changeTenant,
        changeUserRoleAccessData: userActions.changeUserRoleAccessData
      },
      dispatch
    );
  }
)(UserProvider);
